import { Tooltip as AntdTooltip } from "antd";

const Tooltip = ({
  title,
  children,
  styles,
  placement,
  overlayInnerStyle,
  trigger = ["hover"],
  className,
  arrow=true,
}: any) => {
  return (
    <AntdTooltip
      arrow={arrow}  
      placement={placement}
      style={styles}
      title={title}
      trigger={trigger}
      overlayInnerStyle={overlayInnerStyle}
      className={className}
    >
      {children}
    </AntdTooltip>
  );
};

export default Tooltip;
